import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  isOnline = signal(typeof navigator === 'undefined' ? true : navigator.onLine);

  constructor() {
    if (typeof window === 'undefined') return; // NOSONAR S7764 — browser-only Angular code
    window.addEventListener('online', () => this.isOnline.set(true)); // NOSONAR S7764 — browser-only Angular code
    window.addEventListener('offline', () => this.isOnline.set(false)); // NOSONAR S7764 — browser-only Angular code
  }
}
